export enum InsuranceMutationTypes {
    SET_MASTER_CONFIG = 'SET_MASTER_CONFIG',
  }
  